import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { usePathname } from 'next/navigation';
import { cn } from '@/utils/cn';
import DynamicSectionTitle from '../Typography/DynamicSectionTitle';
import RecentlyViewedSlider from '../Slider/RecentlyViewedSlider';

function RecentlyViewedCarousel({ section }) {
  const pathname = usePathname();
  const [showTitle, setShowTitle] = useState(true);

  const { lang: selectLang } = useSelector((state) => state.globalSettings);
  const { items: recentViewedItems } = useSelector(
    (state) => state.recentlyViewed,
  );

  const isPDP = () => pathname.startsWith('/product/');

  if (Array.isArray(recentViewedItems) && recentViewedItems?.length === 0)
    return null;

  return (
    <div>
      {showTitle ? (
        <section className="recently-viewed mb-24 lg:mb-48">
          <div
            className={cn('container mx-auto', {
              '3xl:max-w-[1440px]': !isPDP,
            })}
          >
            <DynamicSectionTitle
              text={section?.title[selectLang]}
              className={cn({
                'text-center': pathname === '/',
              })}
            />
          </div>
          <RecentlyViewedSlider setShowTitle={setShowTitle} />
        </section>
      ) : null}
    </div>
  );
}

export default RecentlyViewedCarousel;
